var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 22.365 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-question-mark",
    "data-name": "Icon open-question-mark",
    d: "M11.115,0C7.29,0,4.455,1.17,2.655,2.97A9.819,9.819,0,0,0,0,8.73l4.5.585A5.453,5.453,0,0,1,5.895,6.21C6.75,5.355,8.1,4.5,11.115,4.5c2.97,0,4.59.72,5.49,1.53A3.762,3.762,0,0,1,17.865,9c0,3.735-1.53,4.77-3.78,6.75s-5.22,4.86-5.22,10.125V27h4.5V25.875c0-3.735,1.4-4.77,3.645-6.75S22.365,14.265,22.365,9A8.645,8.645,0,0,0,19.71,2.655C17.775.9,14.895,0,11.115,0ZM8.865,31.5V36h4.5V31.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.82d1e24b8a09124a8be7e35b89f0e7f9.svg";
export { ForwardRef as ReactComponent };